export const platforms = [
  { code: "PC", name: "PC" },
  { code: "PS4", name: "PS4" },
  { code: "Xbox", name: "Xbox" },
  { code: "Nintendo", name: "Nintendo" },
  { code: "PS5", name: "PS5" },
];

export const categories = [
  { code: "Game Item", name: "Game Item" },
  { code: "Game Boosting & Coaching", name: "Game Boosting & Coaching" },
  { code: "Game Coins", name: "Game Coins" },
  { code: "Gift cards and Top up", name: "Gift cards and Top up" },
  { code: "Game account", name: "Game account" },
];

export const _countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo (Congo-Brazzaville)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czechia (Czech Republic)",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini (fmr. 'Swaziland')",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar (formerly Burma)",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine State",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States of America",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe"
]

export const countries = [
  { code: "93", name: "Afghanistan" },
  { code: "355", name: "Albania" },
  { code: "213", name: "Algeria" },
  { code: "376", name: "Andorra" },
  { code: "244", name: "Angola" },
  { code: "1", name: "Antigua and Barbuda" },
  { code: "54", name: "Argentina" },
  { code: "374", name: "Armenia" },
  { code: "61", name: "Australia" },
  { code: "43", name: "Austria" },
  { code: "994", name: "Azerbaijan" },
  { code: "1", name: "Bahamas" },
  { code: "973", name: "Bahrain" },
  { code: "880", name: "Bangladesh" },
  { code: "1", name: "Barbados" },
  { code: "375", name: "Belarus" },
  { code: "32", name: "Belgium" },
  { code: "501", name: "Belize" },
  { code: "229", name: "Benin" },
  { code: "975", name: "Bhutan" },
  { code: "591", name: "Bolivia" },
  { code: "387", name: "Bosnia and Herzegovina" },
  { code: "267", name: "Botswana" },
  { code: "55", name: "Brazil" },
  { code: "359", name: "Bulgaria" },
  { code: "226", name: "Burkina Faso" },
  { code: "257", name: "Burundi" },
  { code: "855", name: "Cambodia" },
  { code: "237", name: "Cameroon" },
  { code: "1", name: "Canada" },
  { code: "238", name: "Cape Verde" },
  { code: "34", name: "Chile" },
  { code: "86", name: "China" },
  { code: "57", name: "Colombia" },
  { code: "506", name: "Costa Rica" },
  { code: "385", name: "Croatia" },
  { code: "53", name: "Cuba" },
  { code: "357", name: "Cyprus" },
  { code: "420", name: "Czech Republic" },
  { code: "45", name: "Denmark" },
  { code: "253", name: "Djibouti" },
  { code: "1", name: "Dominica" },
  { code: "809", name: "Dominican Republic" },
  { code: "593", name: "Ecuador" },
  { code: "20", name: "Egypt" },
  { code: "503", name: "El Salvador" },
  { code: "240", name: "Equatorial Guinea" },
  { code: "291", name: "Eritrea" },
  { code: "372", name: "Estonia" },
  { code: "251", name: "Ethiopia" },
  { code: "500", name: "Falkland Islands" },
  { code: "298", name: "Faroe Islands" },
  { code: "679", name: "Fiji" },
  { code: "358", name: "Finland" },
  { code: "33", name: "France" },
  { code: "241", name: "Gabon" },
  { code: "220", name: "Gambia" },
  { code: "995", name: "Georgia" },
  { code: "49", name: "Germany" },
  { code: "233", name: "Ghana" },
  { code: "350", name: "Gibraltar" },
  { code: "30", name: "Greece" },
  { code: "1", name: "Grenada" },
  { code: "502", name: "Guatemala" },
  { code: "224", name: "Guinea" },
  { code: "245", name: "Guinea-Bissau" },
  { code: "592", name: "Guyana" },
  { code: "509", name: "Haiti" },
  { code: "504", name: "Honduras" },
  { code: "36", name: "Hungary" },
  { code: "354", name: "Iceland" },
  { code: "91", name: "India" },
  { code: "62", name: "Indonesia" },
  { code: "98", name: "Iran" },
  { code: "964", name: "Iraq" },
  { code: "353", name: "Ireland" },
  { code: "972", name: "Israel" },
  { code: "39", name: "Italy" },
  { code: "1", name: "Jamaica" },
  { code: "81", name: "Japan" },
  { code: "962", name: "Jordan" },
  { code: "254", name: "Kenya" },
  { code: "686", name: "Kiribati" },
  { code: "965", name: "Kuwait" },
  { code: "996", name: "Kyrgyzstan" },
  { code: "856", name: "Laos" },
  { code: "371", name: "Latvia" },
  { code: "961", name: "Lebanon" },
  { code: "266", name: "Lesotho" },
  { code: "231", name: "Liberia" },
  { code: "218", name: "Libya" },
  { code: "423", name: "Liechtenstein" },
  { code: "370", name: "Lithuania" },
  { code: "352", name: "Luxembourg" },
  { code: "853", name: "Macao" },
  { code: "389", name: "Macedonia" },
  { code: "261", name: "Madagascar" },
  { code: "265", name: "Malawi" },
  { code: "60", name: "Malaysia" },
  { code: "960", name: "Maldives" },
  { code: "223", name: "Mali" },
  { code: "356", name: "Malta" },
  { code: "1", name: "Marshall Islands" },
  { code: "222", name: "Mauritania" },
  { code: "230", name: "Mauritius" },
  { code: "262", name: "Mayotte" },
  { code: "52", name: "Mexico" },
  { code: "691", name: "Micronesia" },
  { code: "373", name: "Moldova" },
  { code: "377", name: "Monaco" },
  { code: "976", name: "Mongolia" },
  { code: "382", name: "Montenegro" },
  { code: "1", name: "Montserrat" },
  { code: "212", name: "Morocco" },
  { code: "258", name: "Mozambique" },
  { code: "95", name: "Myanmar" },
  { code: "264", name: "Namibia" },
  { code: "674", name: "Nauru" },
  { code: "977", name: "Nepal" },
  { code: "31", name: "Netherlands" },
  { code: "599", name: "Netherlands Antilles" },
  { code: "1", name: "New Zealand" },
  { code: "505", name: "Nicaragua" },
  { code: "227", name: "Niger" },
  { code: "234", name: "Nigeria" },
  { code: "683", name: "Niue" },
  { code: "850", name: "North Korea" },
  { code: "47", name: "Norway" },
  { code: "968", name: "Oman" },
  { code: "92", name: "Pakistan" },
  { code: "680", name: "Palau" },
  { code: "970", name: "Palestine" },
  { code: "595", name: "Paraguay" },
  { code: "51", name: "Peru" },
  { code: "63", name: "Philippines" },
  { code: "48", name: "Poland" },
  { code: "351", name: "Portugal" },
  { code: "1", name: "Puerto Rico" },
  { code: "974", name: "Qatar" },
  { code: "40", name: "Romania" },
  { code: "7", name: "Russia" },
  { code: "250", name: "Rwanda" },
  { code: "1-869", name: "Saint Kitts and Nevis" },
  { code: "1-758", name: "Saint Lucia" },
  { code: "1-784", name: "Saint Vincent and the Grenadines" },
  { code: "685", name: "Samoa" },
  { code: "378", name: "San Marino" },
  { code: "239", name: "Sao Tome and Principe" },
  { code: "966", name: "Saudi Arabia" },
  { code: "221", name: "Senegal" },
  { code: "381", name: "Serbia" },
  { code: "248", name: "Seychelles" },
  { code: "232", name: "Sierra Leone" },
  { code: "65", name: "Singapore" },
  { code: "421", name: "Slovakia" },
  { code: "386", name: "Slovenia" },
  { code: "677", name: "Solomon Islands" },
  { code: "252", name: "Somalia" },
  { code: "27", name: "South Africa" },
  { code: "82", name: "South Korea" },
  { code: "211", name: "South Sudan" },
  { code: "34", name: "Spain" },
  { code: "94", name: "Sri Lanka" },
  { code: "249", name: "Sudan" },
  { code: "597", name: "Suriname" },
  { code: "46", name: "Sweden" },
  { code: "41", name: "Switzerland" },
  { code: "963", name: "Syria" },
  { code: "886", name: "Taiwan" },
  { code: "992", name: "Tajikistan" },
  { code: "255", name: "Tanzania" },
  { code: "66", name: "Thailand" },
  { code: "670", name: "Timor-Leste" },
  { code: "228", name: "Togo" },
  { code: "676", name: "Tonga" },
  { code: "1-868", name: "Trinidad and Tobago" },
  { code: "216", name: "Tunisia" },
  { code: "90", name: "Turkey" },
  { code: "993", name: "Turkmenistan" },
  { code: "688", name: "Tuvalu" },
  { code: "256", name: "Uganda" },
  { code: "380", name: "Ukraine" },
  { code: "971", name: "United Arab Emirates" },
  { code: "44", name: "United Kingdom" },
  { code: "1", name: "United States of America" },
  { code: "598", name: "Uruguay" },
  { code: "998", name: "Uzbekistan" },
  { code: "678", name: "Vanuatu" },
  { code: "39", name: "Vatican City" },
  { code: "58", name: "Venezuela" },
  { code: "84", name: "Vietnam" },
  { code: "967", name: "Yemen" },
  { code: "260", name: "Zambia" },
  { code: "263", name: "Zimbabwe" }
]


export const countriesplus = [
  { code: "+93", name: "Afghanistan" },
  { code: "+355", name: "Albania" },
  { code: "+213", name: "Algeria" },
  { code: "+376", name: "Andorra" },
  { code: "+244", name: "Angola" },
  { code: "+1", name: "Antigua and Barbuda" },
  { code: "+54", name: "Argentina" },
  { code: "+374", name: "Armenia" },
  { code: "+61", name: "Australia" },
  { code: "+43", name: "Austria" },
  { code: "+994", name: "Azerbaijan" },
  { code: "+1", name: "Bahamas" },
  { code: "+973", name: "Bahrain" },
  { code: "+880", name: "Bangladesh" },
  { code: "+1", name: "Barbados" },
  { code: "+375", name: "Belarus" },
  { code: "+32", name: "Belgium" },
  { code: "+501", name: "Belize" },
  { code: "+229", name: "Benin" },
  { code: "+975", name: "Bhutan" },
  { code: "+591", name: "Bolivia" },
  { code: "+387", name: "Bosnia and Herzegovina" },
  { code: "+267", name: "Botswana" },
  { code: "+55", name: "Brazil" },
  { code: "+359", name: "Bulgaria" },
  { code: "+226", name: "Burkina Faso" },
  { code: "+257", name: "Burundi" },
  { code: "+855", name: "Cambodia" },
  { code: "+237", name: "Cameroon" },
  { code: "+1", name: "Canada" },
  { code: "+238", name: "Cape Verde" },
  { code: "+34", name: "Chile" },
  { code: "+86", name: "China" },
  { code: "+57", name: "Colombia" },
  { code: "+506", name: "Costa Rica" },
  { code: "+385", name: "Croatia" },
  { code: "+53", name: "Cuba" },
  { code: "+357", name: "Cyprus" },
  { code: "+420", name: "Czech Republic" },
  { code: "+45", name: "Denmark" },
  { code: "+253", name: "Djibouti" },
  { code: "+1", name: "Dominica" },
  { code: "+809", name: "Dominican Republic" },
  { code: "+593", name: "Ecuador" },
  { code: "+20", name: "Egypt" },
  { code: "+503", name: "El Salvador" },
  { code: "+240", name: "Equatorial Guinea" },
  { code: "+291", name: "Eritrea" },
  { code: "+372", name: "Estonia" },
  { code: "+251", name: "Ethiopia" },
  { code: "+500", name: "Falkland Islands" },
  { code: "+298", name: "Faroe Islands" },
  { code: "+679", name: "Fiji" },
  { code: "+358", name: "Finland" },
  { code: "+33", name: "France" },
  { code: "+241", name: "Gabon" },
  { code: "+220", name: "Gambia" },
  { code: "+995", name: "Georgia" },
  { code: "+49", name: "Germany" },
  { code: "+233", name: "Ghana" },
  { code: "+350", name: "Gibraltar" },
  { code: "+30", name: "Greece" },
  { code: "+1", name: "Grenada" },
  { code: "+502", name: "Guatemala" },
  { code: "+224", name: "Guinea" },
  { code: "+245", name: "Guinea-Bissau" },
  { code: "+592", name: "Guyana" },
  { code: "+509", name: "Haiti" },
  { code: "+504", name: "Honduras" },
  { code: "+36", name: "Hungary" },
  { code: "+354", name: "Iceland" },
  { code: "+91", name: "India" },
  { code: "+62", name: "Indonesia" },
  { code: "+98", name: "Iran" },
  { code: "+964", name: "Iraq" },
  { code: "+353", name: "Ireland" },
  { code: "+972", name: "Israel" },
  { code: "+39", name: "Italy" },
  { code: "+1", name: "Jamaica" },
  { code: "+81", name: "Japan" },
  { code: "+962", name: "Jordan" },
  { code: "+254", name: "Kenya" },
  { code: "+686", name: "Kiribati" },
  { code: "+965", name: "Kuwait" },
  { code: "+996", name: "Kyrgyzstan" },
  { code: "+856", name: "Laos" },
  { code: "+371", name: "Latvia" },
  { code: "+961", name: "Lebanon" },
  { code: "+266", name: "Lesotho" },
  { code: "+231", name: "Liberia" },
  { code: "+218", name: "Libya" },
  { code: "+423", name: "Liechtenstein" },
  { code: "+370", name: "Lithuania" },
  { code: "+352", name: "Luxembourg" },
  { code: "+853", name: "Macao" },
  { code: "+389", name: "Macedonia" },
  { code: "+261", name: "Madagascar" },
  { code: "+265", name: "Malawi" },
  { code: "+60", name: "Malaysia" },
  { code: "+960", name: "Maldives" },
  { code: "+223", name: "Mali" },
  { code: "+356", name: "Malta" },
  { code: "+1", name: "Marshall Islands" },
  { code: "+222", name: "Mauritania" },
  { code: "+230", name: "Mauritius" },
  { code: "+262", name: "Mayotte" },
  { code: "+52", name: "Mexico" },
  { code: "+691", name: "Micronesia" },
  { code: "+373", name: "Moldova" },
  { code: "+377", name: "Monaco" },
  { code: "+976", name: "Mongolia" },
  { code: "+382", name: "Montenegro" },
  { code: "+1", name: "Montserrat" },
  { code: "+212", name: "Morocco" },
  { code: "+258", name: "Mozambique" },
  { code: "+95", name: "Myanmar" },
  { code: "+264", name: "Namibia" },
  { code: "+674", name: "Nauru" },
  { code: "+977", name: "Nepal" },
  { code: "+31", name: "Netherlands" },
  { code: "+599", name: "Netherlands Antilles" },
  { code: "+1", name: "New Zealand" },
  { code: "+505", name: "Nicaragua" },
  { code: "+227", name: "Niger" },
  { code: "+234", name: "Nigeria" },
  { code: "+683", name: "Niue" },
  { code: "+850", name: "North Korea" },
  { code: "+47", name: "Norway" },
  { code: "+968", name: "Oman" },
  { code: "+92", name: "Pakistan" },
  { code: "+680", name: "Palau" },
  { code: "+970", name: "Palestine" },
  { code: "+595", name: "Paraguay" },
  { code: "+51", name: "Peru" },
  { code: "+63", name: "Philippines" },
  { code: "+48", name: "Poland" },
  { code: "+351", name: "Portugal" },
  { code: "+1", name: "Puerto Rico" },
  { code: "+974", name: "Qatar" },
  { code: "+40", name: "Romania" },
  { code: "+7", name: "Russia" },
  { code: "+250", name: "Rwanda" },
  { code: "+1-869", name: "Saint Kitts and Nevis" },
  { code: "+1-758", name: "Saint Lucia" },
  { code: "+1-784", name: "Saint Vincent and the Grenadines" },
  { code: "+685", name: "Samoa" },
  { code: "+378", name: "San Marino" },
  { code: "+239", name: "Sao Tome and Principe" },
  { code: "+966", name: "Saudi Arabia" },
  { code: "+221", name: "Senegal" },
  { code: "+381", name: "Serbia" },
  { code: "+248", name: "Seychelles" },
  { code: "+232", name: "Sierra Leone" },
  { code: "+65", name: "Singapore" },
  { code: "+421", name: "Slovakia" },
  { code: "+386", name: "Slovenia" },
  { code: "+677", name: "Solomon Islands" },
  { code: "+252", name: "Somalia" },
  { code: "+27", name: "South Africa" },
  { code: "+82", name: "South Korea" },
  { code: "+211", name: "South Sudan" },
  { code: "+34", name: "Spain" },
  { code: "+94", name: "Sri Lanka" },
  { code: "+249", name: "Sudan" },
  { code: "+597", name: "Suriname" },
  { code: "+46", name: "Sweden" },
  { code: "+41", name: "Switzerland" },
  { code: "+963", name: "Syria" },
  { code: "+886", name: "Taiwan" },
  { code: "+992", name: "Tajikistan" },
  { code: "+255", name: "Tanzania" },
  { code: "+66", name: "Thailand" },
  { code: "+670", name: "Timor-Leste" },
  { code: "+228", name: "Togo" },
  { code: "+676", name: "Tonga" },
  { code: "+1-868", name: "Trinidad and Tobago" },
  { code: "+216", name: "Tunisia" },
  { code: "+90", name: "Turkey" },
  { code: "+993", name: "Turkmenistan" },
  { code: "+688", name: "Tuvalu" },
  { code: "+256", name: "Uganda" },
  { code: "+380", name: "Ukraine" },
  { code: "+971", name: "United Arab Emirates" },
  { code: "+44", name: "United Kingdom" },
  { code: "+1", name: "United States of America" },
  { code: "+598", name: "Uruguay" },
  { code: "+998", name: "Uzbekistan" },
  { code: "+678", name: "Vanuatu" },
  { code: "+39", name: "Vatican City" },
  { code: "+58", name: "Venezuela" },
  { code: "+84", name: "Vietnam" },
  { code: "+967", name: "Yemen" },
  { code: "+260", name: "Zambia" },
  { code: "+263", name: "Zimbabwe" }
]


export const regions = [
  { code: "US", name: "US" },
  { code: "Europe", name: "Europe" },
  { code: "Great Britain", name: "Great Britain" },
  { code: "South Korea", name: "South Korea" },
  { code: "Russia", name: "Russia" },
  { code: "Canada", name: "Canada" },
  { code: "Australia", name: "Australia" },
  { code: "UAE", name: "UAE" },
  { code: "Singapore", name: "Singapore" },
  { code: "Kuwait", name: "Kuwait" },
  { code: "South Africa", name: "South Africa" },
  { code: "Vietnam", name: "Vietnam" },
  { code: "Argentina", name: "Argentina" },
  { code: "Bahrain", name: "Bahrain" },
  { code: "Brazil", name: "Brazil" },
  { code: "Chile", name: "Chile" },
  { code: "Colombia", name: "Colombia" },
  { code: "GLOBAL", name: "Global" },
  { code: "Hong Kong", name: "Hong Kong" },
  { code: "Indonesia", name: "Indonesia" },
  { code: "India", name: "India" },
  { code: "Italy", name: "Italy" },
  { code: "Japan", name: "Japan" },
  { code: "Mexico", name: "Mexico" },
  { code: "Myanmar", name: "Myanmar" },
  { code: "Oman", name: "Oman" },
  { code: "Peru", name: "Peru" },
  { code: "Philippines", name: "Philippines" },
  { code: "Qatar", name: "Qatar" },
  { code: "Thailand", name: "Thailand" },
  { code: "Turkey", name: "Turkey" },
  { code: "Taiwan", name: "Taiwan" },
  { code: "Ukraine", name: "Ukraine" },
  { code: "Saudi Arabia", name: "Saudi Arabia" },
];

export const currencies = [
  { code: "USD", name: "USD" },
  { code: "EUR", name: "EUR" },
  { code: "GBP", name: "GBP" },
  { code: "KRW", name: "KRW" },
  { code: "RUB", name: "RUB" },
  { code: "CAD", name: "CAD" },
  { code: "AUD", name: "AUD" },
  { code: "AED", name: "AED" },
  { code: "SGD", name: "SGD" },
  { code: "KWD", name: "KWD" },
  { code: "ZAR", name: "ZAR" },
  { code: "VND", name: "VND" },
  { code: "ARS", name: "ARS" },
  { code: "BHD", name: "BHD" },
  { code: "BRL", name: "BRL" },
  { code: "CLP", name: "CLP" },
  { code: "COP", name: "COP" },
  { code: "XXX", name: "XXX" },
  { code: "HKD", name: "HKD" },
  { code: "IDR", name: "IDR" },
  { code: "INR", name: "INR" },
  { code: "JPY", name: "JPY" },
  { code: "MXN", name: "MXN" },
  { code: "MMK", name: "MMK" },
  { code: "OMR", name: "OMR" },
  { code: "PEN", name: "PEN" },
  { code: "PHP", name: "PHP" },
  { code: "QAR", name: "QAR" },
  { code: "THB", name: "THB" },
  { code: "TRY", name: "TRY" },
  { code: "TWD", name: "TWD" },
  { code: "UAH", name: "UAH" },
  { code: "SAR", name: "SAR" },
];

export const statuslist = [
  { code: "available", name: "Available" },
  { code: "sold out", name: "Sold out" },
];

export const adTypes = [
  { code: "sell", name: "Sell" },
  { code: "trade", name: "Trade" },
];

export const filterOptions = [
  { key: "platform", label: "Platform" },
  { key: "category", label: "Category" },
  { key: "minPrice", label: "MinPrice" },
  { key: "maxPrice", label: "MaxPrice" },
  { key: "currency", label: "Currency" },
  { key: "adType", label: "AdType" },
  { key: "status", label: "Status" },
  { key: "region", label: "Region" },
  { key: "userId", label: "UserId" },
  { key: "year", label: "Year" },
  { key: "month", label: "Month" },
  { key: "day", label: "Day" },
];
